export class BaseResponse<T> {
  public success: boolean
  public message: string
  public ids: any
  public data: T

  constructor(success: boolean, message: string, ids: any, data: T) {
    this.success = success
    this.message = message
    this.ids = ids
    this.data = data
  }
}
